import dayjs from "dayjs";
import React from "react";
import R from "ramda";
import NumberFormat from "react-number-format";
import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    amount: PropTypes.string,
    currencyCode: PropTypes.string,
    paymentProvider: PropTypes.string,
    recordType: PropTypes.string,
    paidAt: PropTypes.string,
  },
  {
    paidAtDate(tr) {
      return dayjs(tr.paidAt).format("MM/DD/YYYY");
    },
    price(tr) {
      const price = tr.recordType === "refund" ? -Math.abs(tr.amount) : tr.amount;

      return (
        <NumberFormat
          value={price}
          prefix="$"
          suffix={` (${tr.currencyCode})`}
          displayType="text"
          decimalScale={2}
          fixedDecimalScale
          thousandSeparator
        />
      );
    },
    paymentForm(tr) {
      switch (tr.paymentProvider) {
        case "recurly":
          return "Credit Card";
        case "paypal":
          return "PayPal";
        case "apple":
          return "Apple IAP";
        case "amazon":
          return "Amazon Pay";

        default:
          return tr.paymentProvider;
      }
    },
    description(tr) {
      if (R.isNil(tr) || R.isNil(tr.offer)) {
        return null;
      }

      return tr.recordType === "refund" ? `Refund for: ${tr.offer.description}` : tr.offer.description;
    },
  },
);
